import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_ADMIN_LISTING,
    ADD_ADMIN,
    UPDATE_ADMIN,
    DELETE_ADMIN,
    EXPORT_ADMIN,
    GET_ADMIN_DETAILS,
    UPDATE_ADMIN_PASSWORD,
} from "./actionTypes.js";

import {
    getAdminListingSuccess,
    getAdminListingFail,
    getAdminDetailsSuccess,
    createAdminSuccess,
    createAdminFail,
    updateAdminSuccess,
    updateAdminFail,
    deleteAdminSuccess,
    deleteAdminFail,
    exportAdminSuccess,
    exportAdminFail,
    getAdminDetailsFail,
    updateAdminPasswordSuccess,
    updateAdminPasswordFail,
} from "./actions.js";

import {
    adminListingApi,
    adminDetailsApi,
    addAdminApi,
    updateAdminApi,
    deleteAdminApi,
    exportAdminApi,
    updateAdminPasswordApi,
} from "./adminApi.js";

function* fetchAdminListing({ payload }) {
    try {
        const response = yield call(adminListingApi, payload);
        yield put(getAdminListingSuccess(response));
    } catch (error) {
        yield put(getAdminListingFail(error));
    }
}

function* fetchAdminDetail({ payload }) {
    try {
        const response = yield call(adminDetailsApi, payload);
        yield put(getAdminDetailsSuccess(response));
    } catch (error) {
        yield put(getAdminDetailsFail(error));
    }
}

function* createAdmin({ payload }) {
    try {
        const response = yield call(addAdminApi, payload);
        yield put(createAdminSuccess(response));
    } catch (error) {
        yield put(createAdminFail(error));
    }
}

function* updateAdmin({ payload }) {
    try {
        const response = yield call(updateAdminApi, payload);
        yield put(updateAdminSuccess(response));
    } catch (error) {
        yield put(updateAdminFail(error));
    }
}

function* updateAdminPassword({ payload }) {
    try {
        const response = yield call(updateAdminPasswordApi, payload);
        yield put(updateAdminPasswordSuccess(response));
    } catch (error) {
        yield put(updateAdminPasswordFail(error));
    }
}

function* deleteAdmin({ payload }) {
    try {
        const response = yield call(deleteAdminApi, payload);
        yield put(deleteAdminSuccess(response));
    } catch (error) {
        yield put(deleteAdminFail(error));
    }
}

function* exportAdmin({ payload }) {
    try {
        const response = yield call(exportAdminApi, payload);
        yield put(exportAdminSuccess(response));
    } catch (error) {
        yield put(exportAdminFail(error));
    }
}

function* AdminSaga() {
    yield takeEvery(GET_ADMIN_LISTING, fetchAdminListing);
    yield takeEvery(GET_ADMIN_DETAILS, fetchAdminDetail);
    yield takeEvery(ADD_ADMIN, createAdmin);
    yield takeEvery(UPDATE_ADMIN, updateAdmin);
    yield takeEvery(UPDATE_ADMIN_PASSWORD, updateAdminPassword);
    yield takeEvery(DELETE_ADMIN, deleteAdmin);
    yield takeEvery(EXPORT_ADMIN, exportAdmin);

}

export default AdminSaga
